module.exports = __webpack_public_path__ + "joy-static/media/BoostIcon.f540d8f4.png";